import { apiFetch } from "@/lib/api";

export type VoiceCallStartRequest = {
  destination_phone_number: string;
  destination_label?: string | null;
  prospect_id?: number | null;
  mode?: "pstn_bridge" | "web_softphone";
};

export type VoiceCallStartResponse = {
  provider: string;
  external_call_id: string;
  status: string;
  active: boolean;
  mode: string;
  agent_phone_number: string;
  destination_phone_number: string;
  started_at: string;
};

export const startVoiceCall = async (data: VoiceCallStartRequest): Promise<VoiceCallStartResponse> => {
  return apiFetch<VoiceCallStartResponse>("/voip/calls", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export type VoiceCallStatusResponse = {
  provider: string;
  external_call_id: string;
  mode: string;
  status: string;
  active: boolean;
  prospect_id?: number | null;
  destination_label?: string | null;
  agent_phone_number: string;
  destination_phone_number: string;
  started_at?: string | null;
  ended_at?: string | null;
  updated_at?: string | null;
};

export const getVoiceCallStatus = async (externalCallId: string): Promise<VoiceCallStatusResponse> => {
  return apiFetch<VoiceCallStatusResponse>(`/voip/calls/${encodeURIComponent(externalCallId)}`);
};

export const getLatestVoiceCallStatus = async (prospectId?: number): Promise<VoiceCallStatusResponse> => {
  const query = new URLSearchParams();
  if (typeof prospectId === "number") {
    query.set("prospectId", String(prospectId));
  }
  return apiFetch<VoiceCallStatusResponse>(`/voip/calls/latest${query.toString() ? `?${query.toString()}` : ""}`);
};
